<mx-object-form (customize)="onCustomize($event)">
    <ng-template mxFormField="oldPassword" mxFormFieldPlacement="replace" let-form="form">
        <mat-form-field class='mxs-input mxs-input--password old-password' [formGroup]="form"
        >
            <mat-label>
                <prl-label value="label.modify.account.old.password"/>
            </mat-label>
            <input matInput
                   formControlName="oldPassword"
                   [required]="true"
                   [type]="hidePassword ? 'password' : 'text'"
                   autocomplete="current-password"
            />
            <mat-icon matSuffix
                      (click)="hidePassword = !hidePassword">{{hidePassword ? 'visibility' : 'visibility_off'}}
            </mat-icon>
        </mat-form-field>
    </ng-template>
</mx-object-form>
